import { PARTNERS_STATS_EVENTS } from './global-events';

export const partnersSlideMenuItems = [
  {
    name: 'Точки продажу ₴',
    event: PARTNERS_STATS_EVENTS.PARTNERS_STATS_AMOUNT,
  },
  {
    name: 'Точки продажу ШТ',
    event: PARTNERS_STATS_EVENTS.PARTNERS_STATS_COUNT,
  },
  {
    name: 'Комісійні винагороди точок продажу ₴',
    event: PARTNERS_STATS_EVENTS.PARTNERS_STATS_EARNINGS,
  },
];
